import React from 'react';
import Shell from '../dashboard/Shell';
import BusinessCardGenerator from './BusinessCardGenerator';
import { useSecureAuth } from '../../contexts/SecureAuthContext';
import { useSelector } from 'react-redux';

export default function BusinessCardPage() {
  const { user } = useSecureAuth();
  const store = useSelector(state => state.store?.current);

  // Prefill data from merchant's store if available
  const prefillData = store ? {
    businessName: store.name || '',
    tagline: store.description || '',
    website: store.customDomain || `${store.slug}.userevstar.com`,
    phone: store.phone || user?.phone || '',
    email: store.email || user?.email || '',
    address: store.address || '',
    // DVA details if available
    bankName: store.dva?.bankName || store.dvaBank || '',
    accountNumber: store.dva?.accountNumber || store.dvaAccountNumber || '',
    accountName: store.dva?.accountName || store.name || '',
    // Social
    instagram: store.socialLinks?.instagram || '',
    whatsapp: store.whatsApp || store.phone || '',
    twitter: store.socialLinks?.twitter || '',
    facebook: store.socialLinks?.facebook || '',
    // QR destination
    qrDestination: store.customDomain
      ? `https://${store.customDomain}`
      : `https://${store.slug}.userevstar.com`,
    // Logo
    logo: store.logo || null,
    // Seed for card accent on first use
    themeAccentColor: store.themeConfig?.primaryColor || null,
  } : null;

  return (
    <Shell>
      <BusinessCardGenerator prefillData={prefillData} />
    </Shell>
  );
}
